"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemWiseSalesLedgerReportSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const itemWiseSalesLedgerReportSubMenu = exports.itemWiseSalesLedgerReportSubMenu = [{
  path: '/report/item-wise-sales-ledger',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/report/item-wise-sales-ledger-report/list.vue'))),
  name: 'report.itemWiseSalesLedgerReport',
  meta: {
    title: 'report.itemWiseSalesLedgerReport.title',
    roles: ['Super Admin', 'Admin', 'Read Only', 'Account Manager'],
    noCache: true,
    hidden: false,
    icon: 'clipboard'
  }
}];